import React, { Component } from "react";
import RankTab from "../../../../../components/Rank/RankTab";
import { get } from "../../../../../utils/request";
import "./style.css";
import "../../../../../index.css";
class SchoolRankIntro extends Component {
  constructor(props) {
    super(props);
    this.state = {
      details: null,
    };
  }
  componentDidMount() {
    this.requestDetails();
  }
  render() {
    const { details } = this.state;
    return (
      <div>
        <RankTab subjectActive={false} schoolActive={true}></RankTab>
        <div className="schoolRankIntro_box">
          <div className="schoolRankIntro_explain_box">
            <img
              alt=""
              className="fl"
              src={require("../../../../../images/rank/star.png")}
            ></img>
            <div className="schoolRankIntro_explain_txt_box fl">
              {details !== null ? details.explain : ""}
            </div>
            <div className="clear"></div>
          </div>
          <div className="schoolRankIntro_name_box">
            {details !== null ? details.short_name : ""}
          </div>
          {details !== null ? (
            <table className="schoolRankIntro_table_box">
              <thead>
                <tr>
                  <th>排名</th>
                  <th>学校名称</th>
                  <th>地区</th>
                  <th>星级</th>
                </tr>
              </thead>
              <tbody>
                {details.rankSchoolList.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>{item.sort===0?'-':item.sort}</td>
                      <td>{item.name}</td>
                      <td>{item.region}</td>
                      <td>{item.star}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            ""
          )}
          <div style={{ height: 60 }}></div>
        </div>
      </div>
    );
  }
  /**
   * 请求大学排名的详情
   */
  requestDetails = () => {
    let hashId = this.props.match.params.hashId;
    get("/public/v1/rank/school/" + hashId).then((res) => {
      this.setState({
        details: res.data,
      });
    });
  };
}

export default SchoolRankIntro;



// WEBPACK FOOTER //
// ./src/containers/Rank/SchoolRank/components/SchoolRankIntro/index.js